((document) => {
  const modalScript = document.querySelector("script[src*=tingle]");

  if (modalScript) {
    const modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "escape"],
      cssClass: ["custom-modal__container"],
      beforeOpen: () => {
        const closeBtn = modal?.modalBoxContent?.querySelector(".custom-modal__close");
        if (closeBtn)
          closeBtn.addEventListener("click", () => {
            modal.close();
          });
        return true;
      },
    });

    document.querySelectorAll(".custom-modal__opener").forEach((opener) => {
      opener.addEventListener("click", () => {
        const title = opener.dataset.modalTitle;
        const description = opener.dataset.modalDescription;
        const image = opener.dataset.modalImage;
        const overlay = opener.dataset.modalOverlay;
        modal.setContent(`
              <div>
                <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
                  <span class="tw-flex tw-items-center tw-gap-1 tw-text-button-3">
                    ${window.icons.checkmark}
                    ${title}
                  </span>
                  <span class="custom-modal__close tw-cursor-pointer">
                    ${window.icons.close}
                  </span>
                </div>
                ${
                  image
                    ? `
                  <div class="tw-relative tw-text-neutral tw-overflow-hidden media--cropped">
                    <img src="${image}" class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover" />
                    ${overlay ? `<span class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-text-body-2 tw-p-4 custom-modal__overlay">${overlay}</span>` : ""}
                  </div>
                  `
                    : ""
                }
                ${description ? `<div class="tw-text-body-1 tw-mt-4">${description}</div>` : ""}
              </div>
            `);
        modal.open();
      });
    });
  }
})(document);
